import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { FC, useState } from "react";

const VideoBanner: FC = () => {
    const [playVideo, setPlayVideo] = useState<boolean>(false);

    return (
        <div className="aspect-[1280/545] w-full relative group">
            {!playVideo && (
                <>
                    <Image
                    src="/images/Car-Spares-For-Sale-1200x511.webp" // use largest image
                    alt="Car Spares For Sale"
                    width={1200}
                    height={511}
                    quality={70}
                    priority
                    fetchPriority="high"
                    placeholder="blur"
                    blurDataURL="/images/Car-Spares-For-Sale-412x175.webp"
                    sizes="(max-width: 640px) 412px, (max-width: 1024px) 751px, 1200px"
                    />
                    {/* Button only visible on hover */}
                    <button
                        title="Play Now" aria-label="Play Now"
                        onClick={() => setPlayVideo(true)}
                        className="absolute inset-0 flex items-center justify-center 
                        bg-black/0 hover:bg-black/40 md:group-hover:bg-black/40 
                        
                        transition-colors duration-300">
                        <div
                            className="opacity-100 md:opacity-0 md:group-hover:opacity-100 
                                    transition-opacity duration-300 ease-in-out 
                                    bg-white rounded-full w-16 h-16 md:w-20 md:h-20 
                                    flex items-center justify-center shadow-lg"
                        >
                            <FontAwesomeIcon icon={faPlay} className="text-primary text-2xl md:text-3xl pl-1" />
                        </div>
                    </button>
                </>
            )}

            {playVideo && (
                <video
                    controls
                    autoPlay
                    playsInline
                    className="w-full h-full object-cover"
                >
                    <source src="/videos/Car-Spares-EzyFind-How-To-Video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    )
}

export default VideoBanner